/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BundleGroupCheckinFinishRequest } from '../../models/bundle-group-checkin-finish-request';
import { BundleGroupCheckinFinishResponse } from '../../models/bundle-group-checkin-finish-response';
import { KeyType } from '../../models/key-type';

export interface FinishBundleGroupCheckin$Params {
  organizationSiteKey: KeyType;
  checkinKey: string;
      body: BundleGroupCheckinFinishRequest
}

export function finishBundleGroupCheckin(http: HttpClient, rootUrl: string, params: FinishBundleGroupCheckin$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroupCheckinFinishResponse>> {
  const rb = new RequestBuilder(rootUrl, finishBundleGroupCheckin.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BundleGroupCheckinFinishResponse>;
    })
  );
}

finishBundleGroupCheckin.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/bundle-group/finish';
